<template>
	<button
		:class="['toggle-btn', buttonClasses]"
		:aria-label="text"
		@click="toggle"
	>
		<span v-if="text === null">
			<slot />
		</span>
		<template v-else>
			<span
				v-if="icon && ! iconRightPlacement"
				class="toggle-icon"
			>
				<img
					:src="iconLink"
					alt="icon"
				>
			</span>
			<span
				v-if="! noText"
				class="toggle-text"
			>
				{{ text }}
			</span>
			<span
				v-if="icon && iconRightPlacement"
				class="toggle-icon"
			>
				<img
					:src="iconLink"
					alt=""
				>
			</span>
			<counter
				v-if="showCounter"
				:counter="counter"
			/>
		</template>
	</button>
</template>

<script>
import { convertToCdnUrl } from 'utils';

export default {
	props: {
		value: {
			type: [Boolean, Number, String, Object],
			default: null,
			required: false,
		},
		text: {
			type: [String, Number],
			default: null,
			required: false,
		},
		icon: {
			type: String,
			default: null,
			required: false,
		},
		iconRightPlacement: {
			type: Boolean,
			default: false,
		},
		counter: {
			type: Number,
			default: null,
			required: false,
		},
		hideEmptyCounter: {
			type: Boolean,
			default: false,
		},
		activeValue: {
			type: [Boolean, Number, String, Object],
			default: true,
		},
		sticky: {
			type: Boolean,
			default: false,
		},
		noText: {
			type: Boolean,
			default: false,
		},
		/* Button sizes:
			large
			normal
			small
			tiny
		*/
		size: {
			type: String,
			default: 'normal',
			required: false,
		},
		/* Extra styling properties */
		center: {
			type: Boolean,
			default: false,
			required: false,
		},
		stretch: {
			type: Boolean,
			default: false,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data () {
		return {
			currentValue: this.value,
		};
	},
	computed: {
		active () {
			return this.value === this.activeValue;
		},
		iconLink () {
			return convertToCdnUrl('/api/dynimg/icon/' + this.icon + '/1A1A1D');
		},
		showCounter () {
			return	this.hideEmptyCounter ?  this.counter : this.counter || this.counter === 0;
		},
		buttonClasses () {
			return [
				{
					'_disabled': this.disabled,
					'_stretch': this.stretch,
					'_center': this.center,
					'active': this.active,
				},
				this.size !== 'normal' ? '_' + this.size : null,
			];
		},
	},
	watch: {
		value (to) {
			this.currentValue = to;
		},
	},
	methods: {
		toggle (ev) {
			this.currentValue = (this.sticky !== false || this.value !== this.activeValue) ? this.activeValue : false;
			this.$emit('input', this.currentValue);
			this.$emit('change', this.currentValue);
			this.$emit('click', ev);
		},
	},
};
</script>
